module.exports = __webpack_public_path__ + "static/media/art.35db0422.jpg";